/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_DescriptionInputs */

const en_csv_to_json_description = /** @type {(inputs: Csv_To_Json_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert CSV data to JSON format online. Transform spreadsheet data into structured JSON arrays.`)
};

const ko_csv_to_json_description = /** @type {(inputs: Csv_To_Json_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV 데이터를 JSON 형식으로 온라인 변환하세요. 스프레드시트 데이터를 구조화된 JSON 배열로 변환합니다.`)
};

const ja_csv_to_json_description = /** @type {(inputs: Csv_To_Json_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSVデータをJSON形式にオンライン変換。スプレッドシートデータを構造化されたJSON配列に変換します。`)
};

/**
* | output |
* | --- |
* | "Convert CSV data to JSON format online. Transform spreadsheet data into structured JSON arrays." |
*
* @param {Csv_To_Json_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_description = /** @type {((inputs?: Csv_To_Json_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_description(inputs)
	if (locale === "ko") return ko_csv_to_json_description(inputs)
	return ja_csv_to_json_description(inputs)
});